/* eslint-disable lingui/no-unlocalized-strings */
export const CF_SESSION_CHANGED = 'x-cf-session-changed';
export const WWW_AUTHENTICATE = 'WWW-Authenticate';
export const STEP_UP_ERROR_NAME = 'INSUFFICIENT_AUTHENTICATION';
export const STEP_UP_ERROR = 'insufficient_user_authentication';
//# sourceMappingURL=response-headers.js.map